import React, { useState, useEffect } from "react";
import api from "@/lib/api";

// Fetches a protected file as a blob URL for <img>
export const useBlobImage = (storagePath) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!storagePath) { setUrl(null); return; }
    let revoke = null;
    let active = true;
    api.get(`/files/${storagePath}`, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        revoke = URL.createObjectURL(res.data);
        setUrl(revoke);
      })
      .catch(() => setUrl(null));
    return () => {
      active = false;
      if (revoke) URL.revokeObjectURL(revoke);
    };
  }, [storagePath]);
  return url;
};
